<template>
  <div class="fieldDiv">
    <div class="fieldDiv_top">
      <div class="back">
		  
		  
        <el-button @click.native="routerGo"
          ><i class="el-icon-arrow-left"></i></el-button
        ><span>{{ title || "" }}</span>
      </div>
      <div class="field_submit">
        <el-button
          class="cancel"
          @click.native="routerGo"
          >取消</el-button
        >
        <el-button class="savebtn" @click.native="saveFieldInfo()"
          >保存</el-button
        >
      </div>
    </div>
    <div class="field_div">
      <div class="field_div_left">
        <div class="module_plate">
          <div class="tit">基础字段</div>
          <div class="module" id="btn">
            <el-button class="options" :data-index="0">单行文字</el-button>
            <el-button class="options" :data-index="1">多行文字</el-button>
            <el-button class="options" :data-index="2">日期</el-button>
            <el-button class="options" :data-index="3">数字</el-button>
            <el-button class="options" :data-index="4">单项选择</el-button>
            <el-button class="options" :data-index="5">多项选择</el-button>
            <el-button class="options" :data-index="6">富文本</el-button>
          </div>
        </div>
      </div>
      <div class="field_div_middle">
        <div class="field_from" id="abc">
          <div class="field_from_module" :class="['not-sort-abc']">
            <div class="field_tit">表头展示</div>
            <div class="field_group" id="tableSort">
              <!-- <template v-for="item in items"> -->
              <template v-for="(item1, index) in sortList">
                <div
                  class="field_item"
                  v-if="
                    item1.value.is_table == 1 && item1.value.table_sort != 0
                  "
                  :data-table_sort="item1.value.table_sort"
                  :key="item1.id"
                >
                  <label class="tit">{{ item1.value.field }} </label>
                  <el-input
                    v-if="item1.value.field_type === 1"
                    class="input_w460"
                    v-model="item1.value.value"
                    disabled
                    :placeholder="item1.value.placeholder"
                    :maxlength="item1.value.maxLength"
                  ></el-input>
                  <el-input
                    v-else-if="item1.value.field_type === 2"
                    class="input_w460"
                    v-model="item1.value.value"
                    disabled
                    :placeholder="item1.value.placeholder"
                    :maxlength="item1.value.maxLength"
                    type="textarea"
                    :rows="1"
                  ></el-input>
                  <el-date-picker
                    v-else-if="item1.value.field_type === 3"
                    v-model="item1.value.value"
                    disabled
                    value-format="timestamp"
                    type="date"
                    :placeholder="item1.value.placeholder"
                    class="input_w460"
                  >
                  </el-date-picker>
                  <el-input
                    v-else-if="item1.value.field_type === 4"
                    :maxlength="item1.value.maxLength"
                    v-model="item1.value.value"
                    disabled
                    :placeholder="item1.value.placeholder"
                    class="input_w460"
                    oninput="value=value.replace(/[^0-9.]/g,'')"
                  >
                  </el-input>
                  <el-select
                    v-else-if="item1.value.field_type === 5"
                    v-model="item1.value.value"
                    disabled
                    :placeholder="item1.value.placeholder"
                    class="input_w460"
                  >
                    <el-option
                      v-for="item2 in item1.value.field_config.list"
                      :key="item2.id"
                      :label="item2.name"
                      :value="item2.id"
                    >
                    </el-option>
                  </el-select>
                  <el-select
                    v-else-if="item1.value.field_type === 6"
                    multiple
                    collapse-tags
                    v-model="item1.value.value"
                    disabled
                    :placeholder="item1.value.placeholder"
                    class="input_w460"
                  >
                    <el-option
                      v-for="item2 in item1.value.field_config.list"
                      :key="item2.id"
                      :label="item2.name"
                      :value="item2.id"
                    >
                    </el-option>
                  </el-select>
                  <p class="input_w920" v-else-if="item1.value.field_type === 18" v-html="item1.value.value"></p>
                </div>
              </template>
              <!-- </template> -->
            </div>
          </div>
          <div
            class="field_from_module"
            v-for="item in items"
            :key="item.type"
            :class="[item.type == 1 ? 'not-sort-abc' : '']"
          >
            <div class="field_tit">
              {{
                item.type == 1
                  ? "基础信息"
                  : item.type == 2
                  ? "需求信息"
                  : item.type == 3
                  ? "需求内容"
                  : ""
              }}
            </div>

            <div class="field_group" :ref="item.type" :data-ref="item.type">
              <div
                v-for="item1 in item.list"
                :key="item1.id"
                :data-id="item1.id"
                :data-ref="item.type"
                :class="[
                  'field_item',
                  item1.is_move == 1 || item1.is_state == 0 ? 'not-sort' : '',
                ]"
                :style="
                  itemsConfig.id === item1.id
                    ? 'background-color: #eff3fd;'
                    : ''
                "
                @click="handleClick(item1)"
              >
                <label class="tit"
                  >{{ item1.field }}{{ item1.is_state == 0 ? "（未启用）" : ""
                  }}<i v-if="item1.required === 1" style="color: red">*</i>
                </label>
                <el-input
                  v-if="item1.field_type === 1"
                  :class="
                    item1.length === 1
                      ? 'input_w230'
                      : item1.length === 0
                      ? 'input_w460'
                      : item1.length === 2
                      ? 'input_w690'
                      : item1.length === 3
                      ? 'input_w920'
                      : 'input_w460'
                  "
                  v-model="item1.value"
                  disabled
                  :placeholder="item1.placeholder"
                  :maxlength="item1.maxLength"
                ></el-input>
                <el-input
                  v-else-if="item1.field_type === 2"
                  :class="
                    item1.length === 1
                      ? 'input_w230'
                      : item1.length === 0
                      ? 'input_w460'
                      : item1.length === 2
                      ? 'input_w690'
                      : item1.length === 3
                      ? 'input_w920'
                      : 'input_w460'
                  "
                  v-model="item1.value"
                  disabled
                  :placeholder="item1.placeholder"
                  :maxlength="item1.maxLength"
                  type="textarea"
                  :rows="1"
                ></el-input>
                <el-date-picker
                  v-else-if="item1.field_type === 3"
                  v-model="item1.value"
                  disabled
                  value-format="timestamp"
                  type="date"
                  :placeholder="item1.placeholder"
                  :class="
                    item1.length === 1
                      ? 'input_w230'
                      : item1.length === 0
                      ? 'input_w460'
                      : item1.length === 2
                      ? 'input_w690'
                      : item1.length === 3
                      ? 'input_w920'
                      : 'input_w460'
                  "
                >
                </el-date-picker>
                <el-input
                  v-else-if="item1.field_type === 4"
                  :maxlength="item1.maxLength"
                  v-model="item1.value"
                  disabled
                  :placeholder="item1.placeholder"
                  :class="
                    item1.length === 1
                      ? 'input_w230'
                      : item1.length === 0
                      ? 'input_w460'
                      : item1.length === 2
                      ? 'input_w690'
                      : item1.length === 3
                      ? 'input_w920'
                      : 'input_w460'
                  "
                  oninput="value=value.replace(/[^0-9.]/g,'')"
                >
                </el-input>
                <el-select
                  v-else-if="item1.field_type === 5"
                  v-model="item1.value"
                  disabled
                  :placeholder="item1.placeholder"
                  @focus="handleClick(item1)"
                  :class="
                    item1.length === 1
                      ? 'input_w230'
                      : item1.length === 0
                      ? 'input_w460'
                      : item1.length === 2
                      ? 'input_w690'
                      : item1.length === 3
                      ? 'input_w920'
                      : 'input_w460'
                  "
                >
                  <el-option
                    v-for="item2 in item1.field_config.list"
                    :key="item2.id"
                    :label="item2.name"
                    :value="item2.id"
                  >
                  </el-option>
                </el-select>
                <el-select
                  v-else-if="item1.field_type === 6"
                  multiple
                  collapse-tags
                  v-model="item1.value"
                  disabled
                  :placeholder="item1.placeholder"
                  @focus="handleClick(item1)"
                  :class="
                    item1.length === 1
                      ? 'input_w230'
                      : item1.length === 0
                      ? 'input_w460'
                      : item1.length === 2
                      ? 'input_w690'
                      : item1.length === 3
                      ? 'input_w920'
                      : 'input_w460'
                  "
                >
                  <el-option
                    v-for="item2 in item1.field_config.list"
                    :key="item2.id"
                    :label="item2.name"
                    :value="item2.id"
                  >
                  </el-option>
                </el-select>
                <template v-else-if="item1.field_type === 18">
                  <vue-ueditor-wrap
                    v-model="item1.value"
                    :config="editorConfig"
                  ></vue-ueditor-wrap>
                </template>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="field_div_right">
        <div class="setting_plate" v-show="itemsConfig.id">
          <div class="show_name">
            编辑字段
            <span v-if="itemsConfig.field_type == 1">（单行文字）</span>
            <span v-else-if="itemsConfig.field_type == 2">（多行文本）</span>
            <span v-else-if="itemsConfig.field_type == 3">（日期）</span>
            <span v-else-if="itemsConfig.field_type == 4">（数字）</span>
            <span v-else-if="itemsConfig.field_type == 5">（单项选择）</span>
            <span v-else-if="itemsConfig.field_type == 6">（多项选择）</span>
            <span v-else-if="itemsConfig.field_type == 18">（富文本）</span>
          </div>
          <div class="setting_info">
            <div class="setting_item">
              <label class="setting_tit"> 标题 </label>
              <el-input
                :disabled="itemsConfig.lock === 1"
                style="width: 223px"
                :class="!rulesField.field ? 'rules' : ''"
                v-model="itemsConfig.field"
                @input="checkRules()"
              ></el-input>
              <div v-show="!rulesField.field" style="color: red">
                请检查标题
              </div>
            </div>
            <div class="setting_item">
              <label class="setting_tit">提示</label>
              <el-input
                style="width: 223px"
                v-model="itemsConfig.placeholder"
              ></el-input>
            </div>
            <div class="setting_item">
              <label class="setting_tit">默认内容</label>
              <el-input
                v-if="itemsConfig.field_type === 1"
                style="width: 223px"
                v-model="itemsConfig.value"
                :placeholder="itemsConfig.placeholder"
                :maxlength="itemsConfig.maxLength"
                clearable
              ></el-input>
              <el-input
                v-else-if="itemsConfig.field_type === 2"
                style="width: 223px"
                v-model="itemsConfig.value"
                :placeholder="itemsConfig.placeholder"
                :maxlength="itemsConfig.maxLength"
                type="textarea"
                :rows="1"
                clearable
              ></el-input>
              <el-date-picker
                v-else-if="itemsConfig.field_type === 3"
                v-model="itemsConfig.value"
                value-format="timestamp"
                type="date"
                :placeholder="itemsConfig.placeholder"
                style="width: 223px"
                clearable
              >
              </el-date-picker>
              <el-input
                v-else-if="itemsConfig.field_type === 4"
                :maxlength="itemsConfig.maxLength"
                v-model="itemsConfig.value"
                :placeholder="itemsConfig.placeholder"
                style="width: 223px"
                oninput="value=value.replace(/[^0-9.]/g,'')"
                clearable
              >
              </el-input>
              <el-select
                v-else-if="itemsConfig.field_type === 5"
                v-model="itemsConfig.value"
                style="width: 223px"
                :placeholder="itemsConfig.placeholder"
                clearable
              >
                <el-option
                  v-for="item2 in itemsConfig.field_config.list"
                  :key="item2.id"
                  :label="item2.name"
                  :value="item2.id"
                >
                </el-option>
              </el-select>
              <el-select
                v-else-if="itemsConfig.field_type === 6"
                multiple
                collapse-tags
                v-model="itemsConfig.value"
                style="width: 223px"
                :placeholder="itemsConfig.placeholder"
                clearable
              >
                <el-option
                  v-for="item2 in itemsConfig.field_config.list"
                  :key="item2.id"
                  :label="item2.name"
                  :value="item2.id"
                >
                </el-option>
              </el-select>
              <p
                v-else-if="itemsConfig.field_type === 18"
                v-html="itemsConfig.value"
              ></p>
            </div>
            <div
              class="setting_item"
              v-show="
                itemsConfig.field_type === 5 || itemsConfig.field_type === 6
              "
            >
              <label class="setting_tit">自定义选项</label>
              <div id="sort_option">
                <template
                  v-if="
                    itemsConfig.field_type === 5 || itemsConfig.field_type === 6
                  "
                >
                  <div
                    v-for="value in itemsConfig.field_config.list"
                    :key="value.id"
                    class="option"
                  >
                    <el-input
                      :disabled="itemsConfig.is_move === 1"
                      placeholder="选项名称"
                      v-model="value.name"
                      maxlength="10"
                      style="margin-bottom: 10px"
                    >
                      <el-button
                        :disabled="itemsConfig.is_move === 1"
                        slot="suffix"
                        class="del"
                        @click="delOption(value.id)"
                        ><a title="删除"
                          ><i
                            class="el-icon-delete"
                            style="font-size: 14px"
                          ></i></a
                      ></el-button>
                      <el-button slot="suffix" class="sort"
                        ><a title="拖动排序"
                          ><i
                            class="el-icon-sort"
                            style="font-size: 14px"
                          ></i></a
                      ></el-button>
                    </el-input>
                  </div>
                </template>
              </div>

              <el-button
                class="add_btn"
                @click="addOption"
                :disabled="itemsConfig.is_move === 1"
                >+ 添加新选项</el-button
              >
            </div>
            <div class="setting_item"
            v-if="![18].includes(itemsConfig.field_type)"
            >
              <label class="setting_tit">字段占比%</label>

              <el-radio-group
                v-model="itemsConfig.length"
                :disabled="itemsConfig.is_move === 1"
              >
                <el-radio-button :label="1">25</el-radio-button>
                <el-radio-button :label="0">50</el-radio-button>
                <el-radio-button :label="2">75</el-radio-button>
                <el-radio-button :label="3">100</el-radio-button>
              </el-radio-group>
            </div>
            <div class="setting_item">
              <el-checkbox
                v-model="itemsConfig.required"
                :disabled="itemsConfig.is_move === 1"
                :true-label="1"
                :false-label="0"
                >这个是必填项</el-checkbox
              >
            </div>
            <div class="setting_item">
              <el-checkbox
                v-model="itemsConfig.is_table"
                :true-label="1"
                :false-label="0"
                @change="changTable()"
                >表头显示</el-checkbox
              >
            </div>
            <div class="setting_item">
              <el-checkbox
                v-model="itemsConfig.is_state"
                :disabled="itemsConfig.is_move === 1"
                :true-label="1"
                :false-label="0"
                @change="changeState()"
                >启用字段</el-checkbox
              >
            </div>
            <div class="setting_item">
              <el-checkbox
                v-model="itemsConfig.is_move"
                :true-label="1"
                :false-label="0"
                >is_move</el-checkbox
              >
            </div>
            <div class="setting_item">
              <el-checkbox
                v-model="itemsConfig.lock"
                :true-label="1"
                :false-label="0"
                >lock</el-checkbox
              >
            </div>
            <div class="setting_item">
              <el-button
                :disabled="itemsConfig.lock === 1"
                @click="deleteFieldShow(itemsConfig.type, itemsConfig.id)"
                >删除字段</el-button
              >
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- 删除字段 -->
    <div class="deleteField">
      <el-dialog
        title="删除字段"
        :visible.sync="setting_show"
        width="400px"
        @before-close="deleteFieldClose()"
      >
        确认删除
        <span class="text-red">{{ itemsConfig.field }}</span>
        字段吗？
        <span slot="footer">
          <el-button class="delbtn" @click="deleteField()">删除</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>
    
    <script>
import Sortable from "sortablejs";
import VueUeditorWrap from "vue-ueditor-wrap";
import {
  updata_customer_form,
  get_customer_form_id,
} from "network/hk_customer";
export default {
  //   name: "CustomerFieldDiv",
  components: {
    VueUeditorWrap,
  },
  data() {
    return {
      form_id: 0,
      title: "",
      itemsConfig: {},
      setting_show: false,
      delFieldInfo: {
        type: null,
        id: null,
      },
      leftList: [
        {
          id: 0,
          store_id: 0,
          field: "单行文字",
          field_type: 1,
          field_config: {
            list: [],
          },
          type: 1,
          is_state: 1,
          lock: 0,
          is_module: 1,
          sort: 1,
          module_detail_type: 0,
          length: 0,
          placeholder: "请输入",
          maxlength: 0,
          required: 0,
          group_id: 0,
          is_move: 0,
          value: "",
          projcet_div_id: 1,
          is_table: 0,
          table_sort: 0,
          operate: 2,
        },
        {
          id: 0,
          store_id: 0,
          field: "多行文字",
          field_type: 2,
          field_config: {
            list: [],
          },
          type: 1,
          is_state: 1,
          lock: 0,
          is_module: 1,
          sort: 1,
          module_detail_type: 0,
          length: 0,
          placeholder: "请输入",
          maxlength: 0,
          required: 0,
          group_id: 0,
          is_move: 0,
          value: "",
          projcet_div_id: 1,
          is_table: 0,
          table_sort: 0,
          operate: 2,
        },
        {
          id: 0,
          store_id: 0,
          field: "日期",
          field_type: 3,
          field_config: {
            list: [],
          },
          type: 1,
          is_state: 1,
          lock: 0,
          is_module: 1,
          sort: 1,
          module_detail_type: 0,
          length: 0,
          placeholder: "请输入",
          maxlength: 0,
          required: 0,
          group_id: 0,
          is_move: 0,
          value: "",
          projcet_div_id: 1,
          is_table: 0,
          table_sort: 0,
          operate: 2,
        },
        {
          id: 0,
          store_id: 0,
          field: "数字",
          field_type: 4,
          field_config: {
            list: [],
          },
          type: 1,
          is_state: 1,
          lock: 0,
          is_module: 1,
          sort: 1,
          module_detail_type: 0,
          length: 0,
          placeholder: "请输入",
          maxlength: 0,
          required: 0,
          group_id: 0,
          is_move: 0,
          value: "",
          projcet_div_id: 1,
          is_table: 0,
          table_sort: 0,
          operate: 2,
        },
        {
          id: 0,
          store_id: 0,
          field: "单项选择",
          field_type: 5,
          field_config: {
            list: [],
          },
          type: 1,
          is_state: 1,
          lock: 0,
          is_module: 1,
          sort: 1,
          module_detail_type: 0,
          length: 0,
          placeholder: "请输入",
          maxlength: 0,
          required: 0,
          group_id: 0,
          is_move: 0,
          value: "",
          projcet_div_id: 1,
          is_table: 0,
          table_sort: 0,
          operate: 2,
        },
        {
          id: 0,
          store_id: 0,
          field: "多项选择",
          field_type: 6,
          field_config: {
            list: [],
          },
          type: 1,
          is_state: 1,
          lock: 0,
          is_module: 1,
          sort: 1,
          module_detail_type: 0,
          length: 0,
          placeholder: "请输入",
          maxlength: 0,
          required: 0,
          group_id: 0,
          is_move: 0,
          value: "",
          projcet_div_id: 1,
          is_table: 0,
          table_sort: 0,
          operate: 2,
        },
        {
          id: 0,
          store_id: 0,
          field: "富文本",
          field_type: 18,
          field_config: {
            list: [],
          },
          type: 1,
          is_state: 1,
          lock: 0,
          is_module: 1,
          sort: 1,
          module_detail_type: 0,
          length: 0,
          placeholder: "请输入",
          maxlength: 0,
          required: 0,
          group_id: 0,
          is_move: 0,
          value: "",
          projcet_div_id: 1,
          is_table: 0,
          table_sort: 0,
          operate: 2,
        },
      ],
      items: [],
      result: [],
      // 记录当前最大的id值
      maxId: 0,
      // 校验编辑字段
      rulesField: {
        all: true,
        field: true,
      },
      // 表头设置
      sortList: [],
      sortId: 0,
      // 删除后的字段配置
      delItems: [],
      // 富文本配置
      editorConfig: {},
    };
  },
  created() {
    let { form_id, title, projcet_div_id } = this.$route.query;
    this.form_id = form_id * 1;
    this.title = title;
    get_customer_form_id(form_id, 2, projcet_div_id).then((res) => {
      if (res.code === 10000) {
        this.result = res.result;
        console.log(
          "🚀 ~ file: CustomerFieldDiv.vue:615 ~ get_customer_form_id ~ this.result:",
          this.result
        );
        this.getFieldConfig();
      } else {
        this.$message({
          message: res.message,
          type: "error",
          offset: 100,
        });
      }
    });
    this.leftList.forEach((ele) => {
      ele.module_detail_type = this.form_id;
      ele.projcet_div_id = projcet_div_id
    });
    this.editorConfig = this.$store.state.UeditorConfig
  },
  mounted() {
    setTimeout(() => {
      for (let i = 0; i < this.items.length; i++) {
        const sortableEl = this.$refs[this.items[i].type][0];
        new Sortable(sortableEl, {
          onAdd: (event) => {
            if (event.item.dataset.index !== undefined) {
              const item = JSON.parse(
                JSON.stringify(this.leftList[event.item.dataset.index])
              );
              const index = this.items.findIndex(
                (element) => element.type == event.to.dataset.ref
              );
              item.id = this.maxId + 1;
              item.type = event.to.dataset.ref * 1;
              this.maxId++;
              this.items[index].list.splice(event.newIndex, 0, item);
              this.itemsConfig = item;
              event.item.parentNode.removeChild(event.item);
            }
          },
          onMove: (event) => {
            if (event.related.classList.contains("not-sort")) {
              return false;
            }
          },
          onEnd: (event) => {
            const index = this.items.findIndex(
              (element) => element.type == event.item.dataset.ref
            );
            const toindex = this.items.findIndex(
              (element) => element.type == event.to.dataset.ref
            );
            if (event.item.dataset.ref !== event.to.dataset.ref) {
              const item = this.items[index].list.splice(event.oldIndex, 1)[0];
              item.type = event.to.dataset.ref * 1;
              this.items[toindex].list.splice(event.newIndex, 0, item);
            } else {
              const item = this.items[index].list.splice(event.oldIndex, 1)[0];
              this.items[index].list.splice(event.newIndex, 0, item);
            }
          },
          filter: ".not-sort",
          group: "shared",
          animation: 150,
        });
      }
      new Sortable(tableSort, {
        animation: 150,
        onEnd: (event) => {
          const item = this.sortList.splice(event.oldIndex, 1)[0];
          this.sortList.splice(event.newIndex, 0, item);
          this.sortList.forEach((ele, index) => {
            ele.value.table_sort = index + 1;
          });
        },
      });
      new Sortable(abc, {
        ghostClass: "sortable-ghost",
        filter: ".not-sort-abc",
        animation: 150,
        scroll: true,
        scrollSensitivity: 500,
        scrollSpeed: 50,
        bubbleScroll: true,
        onMove: (event) => {
          if (event.related.classList.contains("not-sort-abc")) {
            return false;
          }
        },
        onEnd: (event) => {
          const item = this.items.splice(event.oldIndex - 1, 1)[0];
          this.items.splice(event.newIndex - 1, 0, item);
        },
      });
      let isMove = false;
      new Sortable(btn, {
        group: {
          name: "shared",
          pull: "clone",
          put: false,
        },
        onMove: (event) => {
          if (event.related.classList.contains("not-sort")) {
            return false;
          }
        },
        onChoose: (event) => {
          isMove = false;
        },
        onClone: (event) => {
          isMove = true;
        },
        onUnchoose: (event) => {
          if (!isMove) {
            this.addField(event.item.dataset.index);
            isMove = false;
          }
        },

        animation: 150,
        sort: false,
      });
      new Sortable(sort_option, {
        ghostClass: "sortable-ghost",
        handle: ".el-icon-sort",
        animation: 150,
        onEnd: (event) => {
          const item = this.itemsConfig.field_config.list.splice(
            event.oldIndex,
            1
          )[0];
          this.itemsConfig.field_config.list.splice(event.newIndex, 0, item);
        },
      });
    }, 500);
  },
  watch: {},
  computed: {},
  methods: {
    route(path) {
      this.$router.replace(path).catch((err) => err);
    },
    // 获取模块字段配置
    getFieldConfig() {
      this.result.forEach((item, index) => {
        if (item.field_config === "") {
          item.field_config = '{"list":[]}';
        }
        item.field_config = JSON.parse(item.field_config);
        if (item.field_type === 5) {
          if (item.value !== "") {
            item.value = item.value * 1;
          }
        }
        if (item.field_type === 6) {
          if (item.value !== "") {
            item.value = item.value.split(",");
            item.value.forEach((ele, i) => {
              item.value[i] = parseInt(ele);
            });
          }
        }
        if (item.id > this.maxId) {
          this.maxId = item.id;
        }
        item.operate = 1;
      });

      this.items = this.result.reduce((groups, item) => {
        const group = groups.find((group) => group.type === item.type);
        if (group) {
          group.list.push(item);
        } else {
          groups.push({
            type: item.type,
            list: [item],
          });
        }
        return groups;
      }, []);
      this.itemsConfig = this.items[0].list[0];
	  console.log(this.items,'this.itemsthis.items')
      // 获取表头信息排序
      this.changTable();
    },
    addField(type) {
      const item = JSON.parse(JSON.stringify(this.leftList[type]));
      item.id = this.maxId + 1;
      this.maxId++;
      const index = this.items.findIndex((ele) => {
        return ele.type === 1;
      });
      this.items[index].list.push(item);
      this.itemsConfig = item;
    },
    // 字段添加选项
    addOption() {
      let maxid = 0;
      this.itemsConfig.field_config.list.forEach((item) => {
        if (item.id > maxid) {
          maxid = item.id;
        }
      });
      let item = {
        id: 0,
        name: "未命名",
      };
      item.id = maxid + 1;
      this.itemsConfig.field_config.list.push(item);
    },
    // 字段选项删除
    delOption(id) {
      let index = this.itemsConfig.field_config.list.findIndex((element) => {
        return element.id === id;
      });
      this.itemsConfig.field_config.list.splice(index, 1);
    },
    // 字段删除弹窗打开
    deleteFieldShow(type, id) {
      this.delFieldInfo.type = type;
      this.delFieldInfo.id = id;
      this.setting_show = true;
    },
    deleteFieldClose() {
      this.setting_show = false;
      this.delFieldInfo.type = null;
      this.delFieldInfo.id = null;
    },
    // 字段删除
    deleteField() {
      let index = this.items.findIndex((element) => {
        return element.type === this.delFieldInfo.type;
      });
      let fieldIndex = this.items[index].list.findIndex((ele) => {
        return ele.id === this.delFieldInfo.id;
      });
      let item = this.items[index].list.splice(fieldIndex, 1)[0];
      if (item.operate === 1) {
        item.operate = 3;
        item.sort = 0;
        this.delItems.push(item);
        this.itemsConfig = this.items[0].list[0];
        this.changTable();
      }
      this.deleteFieldClose();
    },
    // 选择字段编辑
    handleClick(value) {
      this.checkRules();
      if (this.rulesField.field) {
        this.itemsConfig = value;
      } else {
        this.$message({
          message: "请检查标题",
          type: "error",
          offset: 100,
        });
      }
    },
    // 编辑字段表单验证
    checkRules() {
      if (this.itemsConfig.field === "") {
        this.rulesField.field = false;
        console.log(
          "🚀 ~ file: CustomerFieldDiv.vue:876 ~ checkRules ~ this.rulesField.field:",
          this.rulesField.field
        );
      } else if (this.itemsConfig.is_move != 1) {
        let arr = ["客户编号", "客户模块", "客户名称", "客户类型", "客户来源"];
        if (arr.includes(this.itemsConfig.field)) {
          this.rulesField.field = false;
        } else {
          this.rulesField.field = true;
        }
      } else {
        this.rulesField.field = true;
      }
    },
	routerGo(){
		this.$router.go(-1)
	},
    // 保存模块表单
    saveFieldInfo() {
      this.checkRules();
      if (this.rulesField.field) {
        let arr = [];
        let sort = 1;
        this.items.forEach((element) => {
          element.list.forEach((ele) => {
            ele.sort = sort++;
            const item = JSON.parse(JSON.stringify(ele));
            if (item.field_type == 6) {
              item.value = item.value.join(",");
            }
            arr.push(item);
          });
        });
        if (this.delItems.length > 0) {
          this.delItems.forEach((ele) => {
            const item = JSON.parse(JSON.stringify(ele));
            if (item.field_type == 6) {
              item.value = item.value.join(",");
            }
            arr.push(item);
          });
        }
        let data = {
          form_id: this.form_id,
          form_data: [],
        };
        data.form_data = JSON.stringify(arr);
        updata_customer_form(data).then((res) => {
          if (res.code === 10000) {
            this.$message({
              message: res.message,
              type: "success",
              offset: 100,
            });
            this.routerGo()
          } else {
            this.$message({
              message: res.message,
              type: "error",
              offset: 100,
            });
          }
        });
      } else {
        this.$message({
          message: "请检查标题",
          type: "error",
          offset: 100,
        });
      }
    },
    // 表头显示和排序
    changTable() {
      this.sortList = [];
      this.items.forEach((item, itemindex) => {
        item.list.forEach((ele, eleindex) => {
          if (ele.is_table == 1) {
            this.sortList.push({
              id: this.sortId++,
              value: ele,
            });
          } else {
            ele.table_sort = 0;
          }
        });
      });
      if (this.sortList.length > 1) {
        this.sortList.sort((a, b) => a.value.table_sort - b.value.table_sort);
      }
      if (this.sortList.length >= 1) {
        let maxSort =
          this.sortList[this.sortList.length - 1].value.table_sort + 1;
        this.sortList.forEach((item) => {
          if (item.value.table_sort == 0) {
            item.value.table_sort = maxSort;
          }
        });
      }
      if (this.sortList.length > 1) {
        this.sortList.sort((a, b) => a.value.table_sort - b.value.table_sort);
      }
    },
    // 字段启用状态
    changeState() {
      if (this.itemsConfig.is_state == 0) {
        let index1 = this.items.findIndex((ele) => {
          return ele.type == this.itemsConfig.type;
        });
        let index2 = this.items[index1].list.findIndex((ele) => {
          return ele.id == this.itemsConfig.id;
        });
        let index3 = this.items[index1].list.length - 1;
        const item = this.items[index1].list.splice(index2, 1)[0];

        this.items[index1].list.splice(index3, 0, item);
      } else {
        let index1 = this.items.findIndex((ele) => {
          return ele.type == this.itemsConfig.type;
        });
        let index2 = this.items[index1].list.findIndex((ele) => {
          return ele.id == this.itemsConfig.id;
        });
        let index3 = 0;
        let indexlast = true;
        const item = this.items[index1].list.splice(index2, 1)[0];
        this.items[index1].list.some((ele, index) => {
          index3 = index;
          if (ele.is_state == 0) {
            indexlast = false;
            return true;
          }
        });
        if (indexlast) {
          index3 = this.items[index1].list.length;
        }
        this.items[index1].list.splice(index3, 0, item);
      }
    },
  },
};
</script>
    
  <style scoped lang="scss">
.not-sort:hover {
  cursor: not-allowed !important;
}

.not-sort-abc {
  .field_tit:hover {
    cursor: not-allowed !important;
  }
}
.blue-background-class {
  background-color: #eff3fd;
}
.rules {
  /deep/ .el-input__inner {
    border-color: red !important;
  }
}
.fieldDiv {
  display: flex;
  flex-direction: column;
}
.fieldDiv_top {
  display: flex;
  width: 100%;
  height: 50px;
  background-color: #ffffff;
  justify-content: space-between;
  flex-direction: row;
  align-items: center;
  position: sticky;
  top: 0px;
  z-index: 2;
  .back {
    margin-left: 10px;
    display: flex;
    align-items: center;
    /deep/ .el-button {
      margin: 0;
      padding: 0;
      font-size: 20px;
      width: 36px;
      height: 36px;
      background-color: #fff;
      color: #5f656c;
      border: none;
      border-radius: 4px;
    }
    /deep/ .el-button:hover {
      background-color: #f4f4f4;
      color: #121315;
    }
  }
  .field_submit {
    margin: 0 20px 0px 0px;
    display: flex;
    flex-direction: row-reverse;
    // width: 1050px;
    /deep/ .el-button {
      margin: 0;
      box-shadow: none !important;
      background-image: none;
      text-shadow: none;
      width: 60px;
      height: 32px;
      padding: 0;
      border: none;
      border-radius: 2px !important;
      font-size: 14px;
      cursor: pointer;
      display: inline-block;
      font-weight: 400;
      text-transform: none;
      text-align: center;
    }
    /deep/ .el-button.savebtn {
      background-color: #2c7ef8;
      color: #fff;
      margin-right: 10px;
    }
    /deep/ .el-button.savebtn:hover {
      background-color: #0e68ef;
    }
    /deep/ .el-button.cancel {
      background-color: #f5f6f8;
      color: #4e5969ff !important;
    }
    /deep/.el-button.cancel:hover {
      background-color: #cccccc;
    }
  }
}
.field_div {
  width: 100%;
  height: 100%;
  background: #fff;
  margin-top: 10px;
  padding-bottom: 15px;
  display: flex;
  justify-content: space-between;
}
.field_div_left {
  min-width: 256px;
  max-width: 256px;
  height: 500px;
  background: #ffffff;
  position: sticky;
  top: 45px;
  z-index: 1;
  .module_plate {
    margin-top: 23px;
    .tit {
      color: #121315;
      font-size: 14px;
      font-weight: 600;
      margin-bottom: 8px;
      margin-left: 14px;
    }
    .module {
      display: flex;
      flex-wrap: wrap;
      /deep/ .el-button.options {
        width: 114px;
        height: 34px;
        border: 1px solid #e6eaf0;
        border-radius: 4px;
        color: #494f57;
        margin: 8px 7px 0 7px;
        cursor: pointer;
        background: #f9fafc;
        padding: 0;
      }
      /deep/ .el-button.options:hover {
        background-color: #f4f6f9;
        font-weight: 600;
        color: #121315;
        border: 1px solid #ccd4e0;
      }
    }
  }
}
.field_div_middle {
  flex-grow: 1;
  background-color: #f9fafc;
  display: flex;
  flex-direction: column;
  align-items: center;
  .field_from {
    padding: 20px 20px 0 20px;
    display: flex;
    flex-direction: column;
    align-items: center;
    .field_from_module {
      display: flex;
      flex-direction: column;
      background: #ffffff;
      box-shadow: 0px 0px 10px #00000014;
      opacity: 1;
      border-radius: 10px;
      margin-bottom: 32px;
      :hover {
      }
      .field_tit {
        font-size: 18px;
        font-weight: 400;
        color: #2e405e;
        padding: 21px 0 20px 25px;
      }
      .field_tit:hover {
        cursor: all-scroll;
      }
      .field_group {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap;
        justify-content: flex-start;
        width: 1050px;
        padding: 0 25px 25px 25px;
        .field_item {
          .tit {
            color: #2e405e;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 10px;
            pointer-events: none;
          }
          display: flex;
          flex-direction: column;
          // margin: 0 25px 25px 0px;
          padding: 15px 15px 15px 15px;
          border-radius: 8px;
          /deep/ .el-input.is-disabled .el-input__inner,
          /deep/ .el-textarea.is-disabled .el-textarea__inner {
            background-color: #ffffff;
            border-color: #e4e7ed;
            color: #c0c4cc;
            pointer-events: none;
          }
        }
        .field_item:hover {
          background-color: #fafafb;
          cursor: all-scroll;
        }

        .field_item_table {
          .tit {
            color: #2e405e;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 10px;
            pointer-events: none;
          }
          .table_value {
            color: #2e405e;
            font-size: 14px;
            font-weight: 400;
            margin-bottom: 10px;
            pointer-events: none;
          }
          display: flex;
          flex-direction: column;
          // margin: 0 25px 25px 0px;
          padding: 15px 15px 15px 15px;
          border-radius: 8px;
          width: 485px;
        }
        .field_item_table:hover {
          background-color: #fafafb;
          cursor: all-scroll;
        }
      }
    }
  }
}
.field_div_right {
  width: 265px;
  height: 100%;
  background: #ffffff;
  display: flex;
  justify-content: center;
  position: sticky;
  top: 45px;
  z-index: 1;
  .setting_plate {
    margin: 10px 7px 0 7px;
    .show_name {
      color: #2e405e;
      font-size: 16px;
      font-weight: 400;
      margin-bottom: 25px;
    }
    .setting_info {
      width: 223px;
      .setting_item {
        color: #2e405e;
        font-size: 14px;
        font-weight: 400;
        display: flex;
        flex-direction: column;
        margin-bottom: 25px;
        .setting_tit {
          color: #2e405e;
          font-size: 14px;
          font-weight: 400;
          margin-bottom: 10px;
        }
        .option {
          display: flex;
          flex-direction: row;
          align-items: center;
          /deep/ .el-input__suffix {
            line-height: 32px;
          }
          .el-button.del,
          .el-button.sort {
            margin: 0;
            padding: 0;
            color: #b0b0b9;
            font-weight: bolder;
            text-align: center;
            width: 20px;
            height: 22px;
            border: none;
          }
          .el-button.del:hover,
          .el-button.sort:hover {
            background: #e6e7e9;
          }
          .el-button.sort:hover {
            cursor: move;
          }
        }
        /deep/ .el-button.add_btn {
          height: 32px;
          padding: 0;
          border-style: dashed;
          color: #494f57;
          background-color: #fff;
        }
        .el-button.add_btn:hover {
          background-color: #f4f4f4;
          color: #494f57 !important;
          border-color: #acb3bd !important;
        }
        /deep/ .el-radio-button {
          height: 36px;
          width: 53px;
        }
        /deep/.el-radio-button__inner {
          padding: 12px 18px;
        }
      }
    }
  }
}
.deleteField {
  /deep/ .el-dialog__header {
    line-height: 1.28571429em;
    border-top-left-radius: 0.25em;
    border-top-right-radius: 0.25em;
    padding: 24px 24px 0;
    height: 50px;
    background-color: #fff;
    border-bottom: none !important;
  }
  /deep/ .el-dialog__title {
    font-weight: 700;
    font-size: 18px;
    color: #2e405e;
  }
  /deep/ .el-dialog__body {
    padding: 24px;
    background: #fff;
    display: block;
    font-size: 14px;
    line-height: 1.4;
    width: 100%;
    color: #2e405e;
  }
  .text-red {
    color: #de350b !important;
  }
  /deep/ .el-dialog__footer {
    padding: 0 24px 24px;
    border-bottom-left-radius: 0.25em;
    border-bottom-right-radius: 0.25em;
    background: transparent;
    text-align: right;
    height: 54px;
    border-top: none !important;
  }
  /deep/ .el-button.delbtn {
    padding: 0;
    margin: 0 0 0 8px;
    background-color: #de350b;
    background-image: none;
    color: #fff;
    text-shadow: none;
    width: 60px !important;
    height: 32px !important;
    border-radius: 0.28571429rem !important;
    border: 0px !important;
    font-weight: 500;
  }
  /deep/ .el-button.delbtn:hover {
    background-color: #bf2600;
  }
}
.input_w920 {
  width: 941px;
  min-height: 32px;
  border-radius: 4px;
}
.input_w460 {
  width: 455px;
  min-height: 32px;
  border-radius: 4px;
}
.input_w690 {
  width: 697px;
  min-height: 32px;
  border-radius: 4px;
}
.input_w230 {
  width: 213px;
  min-height: 32px;
  border-radius: 4px;
}
</style>
    